export const KEY_REDUCER_TOC = "toc";
